(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const syncHomeProductTitle = (scope = document) => {
    const section = scope.querySelector?.('main[data-template="index"] .raev-drop-section')
      || document.querySelector('main[data-template="index"] .raev-drop-section');

    if (!section) return;

    const grid = section.querySelector('.raev-drop-grid');
    const imageBox = section.querySelector('.raev-drop-image-box');
    const content = section.querySelector('.raev-drop-content');
    const kicker = content?.querySelector('.raev-drop-kicker');
    const title = section.querySelector('.raev-drop-title');

    if (!grid || !imageBox || !content || !title) return;

    if (mobileQuery.matches) {
      if (title.parentElement !== grid || title.nextElementSibling !== imageBox) {
        grid.insertBefore(title, imageBox);
      }
      title.setAttribute('data-raev-home-title-moved', '');
      return;
    }

    if (title.parentElement !== content) {
      if (kicker?.parentElement === content) {
        kicker.insertAdjacentElement('afterend', title);
      } else {
        content.insertBefore(title, content.firstChild);
      }
    }
    title.removeAttribute('data-raev-home-title-moved');
  };

  const run = () => syncHomeProductTitle(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  mobileQuery.addEventListener?.('change', run);
  document.addEventListener('shopify:section:load', (event) => syncHomeProductTitle(event.target));
})();
